module.exports = __webpack_public_path__ + "img/P8.86fa7f19.png";